// Convert composed nodeId like "abc123|2" => { id: "abc123", level: 2 }
export const parseComposedId = (composedId) => {
  if (!composedId) return { id: null, level: null };
  const [id, levelStr] = composedId.split('|');
  return { id, level: Number(levelStr) };
};

// Create a composed ID like "abc123|2"
export const getComposeNodeId = (id, level) => `${id}|${level}`;

// Check if node is a leaf (i.e. can’t have children)
export const isLeafNode = (node, maxDepth) => {
  return !!node.features?.length || node.level >= maxDepth;
};

// Flatten tree to array of all nodes
export const flattenTree = (nodes) => {
  return nodes.flatMap((node) => [
    node,
    ...(node.children?.length ? flattenTree(node.children) : []),
  ]);
};

// Generate label for level panel (adds emoji if desired)
export const getLevelLabel = (levelName, index) => {
  const emojis = ['📁', '📂', '📄', '📌', '🔖'];
  return `${emojis[index % emojis.length]} ${levelName}`;
};

// Debounce function
export const debounce = (fn, delay = 300) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
};
